// @flow
import * as React from "react";
import { withTranslation } from "react-i18next";
import { type FormProps, reduxForm } from "redux-form";

import SaveButton from "../SaveButton";
import Section from "../Section";
import { sagaConnector } from "Commons/Utilities/redux";

import { PhoneNumber } from "modules/ChangeService/components/FormComponents/PhoneNumber";
import { DateOfBirth } from "modules/ChangeService/components/FormComponents";

type Props = {
  t: typeof TFunction,
  hideSaveButton?: boolean,
} & FormProps;

let AdditionalInformation = (props: Props) => {
  const {
    t,
    invalid,
    submitFailed,
    submitting,
    submitSucceeded,
    handleSubmit,
    hideSaveButton = false,
    mobileChangeService = false,
    divider,
  } = props;

  return (
    <Section title={t("wizard.customer.additionalInformation")} id="additionalInformation">
      <PhoneNumber divider={divider} mobileChangeService={mobileChangeService} />
      <DateOfBirth divider={divider} mobileChangeService={mobileChangeService} />
      {!hideSaveButton && (
        <SaveButton
          invalid={invalid}
          submitting={submitting}
          error={submitFailed}
          submitSucceeded={submitSucceeded}
          onClick={handleSubmit}
        />
      )}
    </Section>
  );
};

AdditionalInformation = withTranslation("changeService")(AdditionalInformation);

export const AdditionalInformationForm = reduxForm({
  onSubmit: (values, dispatch) => {
    return sagaConnector(
      "UPDATE_CHANGE_SERVICE_REQUESTED",
      "UPDATE_CHANGE_SERVICE_SUCCEEDED",
      "UPDATE_CHANGE_SERVICE_FAILED",
      {
        changeService: values,
        userId: values.userId,
        id: values.id,
        categoryId: values.categoryId,
      },
      dispatch
    );
  },
})(AdditionalInformation);

export default AdditionalInformation;
